import React, { useMemo } from 'react'
import * as $ from 'jquery';
import { connect, useDispatch } from 'react-redux'
import { initializePatientTemplateAttributes } from '../../../../itrust_common/components/HelperFunctions'
import { useHistory } from 'react-router-dom';
import { quickActions } from '../../../../redux/actions/dashboard/quickActionActions';
import { appointmentEdit } from '../../../../redux/actions/appointmentActions';
import Alert from '../../../../itrust_common/components/Alert';
import { patientTemplateLoad } from '../../../../redux/actions/public/PatientTemplateActions';
import { getQuickActionColumns, getVisibleQuickActions } from './quickActionsColumns'

function QuickActions(props) {
  const { currentStoreId, currentUserRole, timeSlotFrequency, whatsAppConfig, quickActionOrder, storeSpecificPatients } = props
  const dispatch = useDispatch()
  const history = useHistory()

  const handlePatientAction = async () => {
    let patientTemplate = await dispatch(patientTemplateLoad());
    patientTemplate = patientTemplate.value.data.patient_template
    const patientData = initializePatientTemplateAttributes(patientTemplate?.personal_information)
    dispatch(quickActions({ select_patient_modal: 'patient', patient: { ...patientData, id: 'New' } }))
    setTimeout(() => $('#fullModePatient-modal').modal({ backdrop: 'static', keyboard: false }), 300);
  }

  const handlePatientSelect = (selectedAction) => {
    dispatch(quickActions({ select_patient_modal: selectedAction }))
    $('#patientSelect-modal').modal('show');
  }

  const handleAppointmentAction = () => {
    dispatch(quickActions({ select_patient_modal: 'appointment' }))
    const appointmentData = {
      comment: '',
      start_time: new Date(),
      end_time: new Date(new Date().getTime() + timeSlotFrequency * 60000),
      store_id: currentStoreId,
      appointment_type: 'in_office',
    }
    dispatch(appointmentEdit('New', appointmentData));
    setTimeout(() => $('#appointmentForm-modal').modal({ backdrop: 'static', keyboard: false }), 300);
  }

  const actionsByKey = useMemo(() => {
    const actions = [
      { title: 'Order', name: 'order', icon: 'la-shopping-cart', onclick: () => handlePatientSelect('order'), storeId: true },
      { title: 'New Patient', name: 'patient', icon: 'la-user-plus', onclick: handlePatientAction, storeId: storeSpecificPatients },
      { title: 'Appointment', name: 'appointment', icon: 'la-calendar', onclick: handleAppointmentAction, storeId: true },
      { title: 'Exam', name: 'exam', icon: 'la-stethoscope', onclick: () => handlePatientSelect('exam'), storeId: true },
      { title: 'Prescription', name: 'prescription', icon: 'la-file-alt', onclick: () => handlePatientSelect('prescription'), storeId: true },
      { title: 'Text Message', name: 'send_text_message', icon: 'la-sms', onclick: () => handlePatientSelect('sms'), storeId: true },
      { title: 'Phone Call', name: 'make_phone_call', icon: 'la-phone-volume', onclick: () => handlePatientSelect('make_call'), storeId: true },
      { title: 'Contact Lens', name: 'add_contact_lens', icon: 'la-glasses', notVisibleTo: ['non_admin'], onclick: () => history.push(`/organisation/stores/${currentStoreId}/settings/order-inventory/contact-lens`), storeId: true },
      { title: 'Insurance', name: 'add_insurance', icon: 'la-medkit', onclick: () => history.push('/settings/insurance/vision-insurance'), notVisibleTo: ['admin', 'non_admin'] },
      { title: 'Contact', name: 'add_contact', icon: 'la-user-circle', notVisibleTo: ['non_admin'], onclick: () => history.push(`/organisation/stores/${currentStoreId}/settings/contact`), storeId: true },
    ]

    if (whatsAppConfig?.visible) {
      actions.splice(6, 0, { title: 'WhatsApp', name: 'whatsapp', icon: 'la-whatsapp', onclick: () => handlePatientSelect('whatsapp'), storeId: true })
    }

    return Object.fromEntries(actions.map((action) => [action.name, action]))
  }, [whatsAppConfig?.visible, storeSpecificPatients, currentStoreId, dispatch, history, timeSlotFrequency])

  const visibleColumns = getVisibleQuickActions(
    getQuickActionColumns(quickActionOrder?.columns),
    (column) => {
      const action = actionsByKey[column.key]
      return action && !action.notVisibleTo?.includes(currentUserRole)
    }
  )

  const handleActionClick = (action) => () => {
    if (action.storeId && !currentStoreId) {
      Alert.warning('Please select store from top dropdown.')
      return
    }
    action.onclick()
  }

  return (
    <div className='d-flex justify-content-between pl-8 pr-6 quick-actions bg-light'>
      <div className='d-flex align-items-center overflow-auto hidden-scroll pb-5'>
        {visibleColumns.map((column) => {
          const action = actionsByKey[column.key]
          return (
            <div
              key={column.key}
              className={`mr-5 bg-white border rounded pl-5 pr-9 py-3 d-flex align-items-center pointer ${action.class} quick-action-hover`}
              onClick={handleActionClick(action)}
            >
              <i className={`la ${action.icon} mr-3`} />
              <span className='text-nowrap line-height-normal'>{action.title}</span>
            </div>
          )
        })}
      </div>
      <div className='bg-primary rounded px-4 pt-3 text-white height-2-half ml-4' id="quickActionDropLink" onClick={() => dispatch(quickActions({ showActionsDropdown: true }))}>
        {visibleColumns.length > 0 ? <i className='la la-plus'/> : <span><i className="la la-plus mr-2 add-action-icon"/>Add Actions</span>}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  currentStoreId: state.currentStore.store.id,
  currentUserRole: state.auth.user.role,
  quickActionOrder: state.auth.user.ordering_preferences?.quick_actions,
  timeSlotFrequency: state.setting.calendarSetting.calendar_setting.time_slot_frequency,
  quickAction: state.dashboard.quickAction,
  whatsAppConfig: state.organisation.organisation.add_ons_config?.type?.whatsapp,
  storeSpecificPatients: state.organisation.organisation.preferences?.store_specific_patients,
})

export default connect(mapStateToProps)(QuickActions)
